export default __webpack_public_path__ + "static/media/MINUSMA_camp_attack.cdd40d54.jpg";